import React,{useRef, useState} from "react"
import { Dropdown,InputDefault } from "../../../../components/ui"
import { useFormik } from 'formik';
import { useQuery } from "react-query";
import { getAllListMember} from "../../../../modules/services/member.service";
import {  getListRewardsAll, getRewardsDetail } from "../../../../modules/services/rewards.service";
import { RedemptionsSchema } from "../../../../modules/helperValidation";



interface Props {
    handleChange: (e: any) => void
    id?: string
    initLoad? : any
    loadings? : any
    codeVoucher?: any
}

const FormRedemptions : React.FC <Props> = ({handleChange, id,initLoad, loadings}) => {
  const resetForms = useRef<any>(null)
    const [idMember, setIdMember] = useState(null)
    const [idRewards, setRewards] = useState( id ? initLoad.reward :null)

    const TypeMaster = [
      { label: 'Approved', value: 'approved' },
    ]

    const initValue = {
      date: '',
      member: '',
      reward:'',
      code: '',
      status:'',
    }


    const { data: dataMembers } = useQuery(['getMember'], async () => await getAllListMember())
    const { data : dataRewards } = useQuery(['getDetailRewards',], async () => await getListRewardsAll())
    const { data: dataVouchers } = useQuery(['getVouchers', idRewards], async () => await getRewardsDetail(idRewards))

    
    const formik = useFormik({
        initialValues : id ? initLoad : initValue,
        onSubmit: (values, {resetForm}) => {
           handleChange(values)
        },
        enableReinitialize:true,
        validationSchema: RedemptionsSchema
    })
    return(
     
        <form id="form-reward-detail" onSubmit={formik.handleSubmit} ref={resetForms}>
            <div className='d-flex flex-column align-items-center gap-4'>
                <div className='mb-3 w-100'>
                  <label htmlFor='date' className='form-label'>
                   Date
                  </label>
                  <InputDefault type='date' id='date' name="date" onChange={formik.handleChange} value={formik.values.date} validation={formik.errors.date && formik.touched.date }  textError={formik.errors.date}    />
                  <label htmlFor='reward' className='form-label'>
                   Reward 
                  </label>
                  <Dropdown  
                    id='reward' 
                    data={dataRewards}  
                    onChanges={(e) => {
                      formik.setFieldValue('reward',e.target.value)
                      setRewards(e.target.value)
                    }}
                    value={formik.values.reward} 
                    validation={formik.errors.date && formik.touched.date } 
                    textError={formik.errors.date}  
                    />
                   
                  <label htmlFor='code' className='form-label'>
                    Voucher Code
                  </label>
                  <Dropdown 
                    id='code' 
                    data={dataVouchers} 
                    onChanges={formik.handleChange} 
                    value={formik.values.code}  
                    validation={formik.errors.code && formik.touched.code } 
                    textError={formik.errors.code}   
                  />
                  <label htmlFor='member' className='form-label'>
                   Member
                  </label>
                  <Dropdown 
                    id={'member'}
                    data={dataMembers}  
                    onChanges={(e) => {
                      formik.setFieldValue('member',e.target.value)
                      setIdMember(e.target.value)
                   }}
                   value={formik.values.member} 
                   validation={formik.errors.member && formik.touched.member } 
                   textError={formik.errors.member}   
                  />
                  <label htmlFor='status' className='form-label'>
                    Status 
                  </label>
                  <Dropdown 
                    id="status"  
                    onChanges={formik.handleChange} 
                    data={TypeMaster} 
                    value={formik.values.status} 
                    validation={formik.errors.status && formik.touched.status } 
                    textError={formik.errors.status}
                  />
                  <div className='card-footer d-flex justify-content-end py-6 px-9'>
                  {!loadings ?  <button
                     className='btn btn-primary'
                     data-bs-target='#add-edit-member'
                     type="submit"
                   >
                      Submit
                  </button> :  <button
                     className='btn btn-primary'
                     data-kt-indicator="on"
                     type="button"
                   >
                     <span className="indicator-progress">Please wait... 
                     <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button> }
                 </div>
                </div>
            </div>
        </form>
      
    )
}

export default FormRedemptions